import { max } from '@vee-validate/rules';
import { defineRule } from 'vee-validate';

defineRule('unique-variant-name', (value, { isDuplicateVariant, rowData }) => {
    if (!isDuplicateVariant(value, rowData)) return true;
    return 'Cannot import the same variant name twice in the same category.';
});

export default {
    data() {
        return {
            productVariantConfiguration: {
                type: 'productvariants',
                label: 'Product Variants',
                importModes: [
                    {value:'add', text:'Add New (Skip when the variant name is already present in the category)'},
                    {value:'update', text:'Update (Skip when the variant name is not present in the category, update when found)'},
                    {value:'addAndUpdate', text:'Add and Update'}
                ],
                sampleNotes: [
                    'Variant Name accepts numbers, letters and special characters',
                    'Category must be Size, Color, or Other',
                    'Active Status must be Yes or No.  Yes = is active, No = is not active',
                    'A variant is identified by its name and category together, so the same name may be used once in each category',
                    'Updating only changes the Active Status, because the name and category are what identify the variant'
                ],
                fields: [
                    {
                        key: 'VariantName',
                        label: 'Variant Name',
                        hasErrorCalculator: (value, row, checkOriginalData) => {
                            return (
                                this.isEmpty(value)
                                || max(value, { length: 80 }) !== true
                                || this.isDuplicateVariant(value, row, checkOriginalData)
                            );
                        },
                        rules: {
                            'unique-variant-name': {
                                isDuplicateVariant: this.isDuplicateVariant
                            },
                            max: {length: 80},
                            required: true
                        },
                        addRowDataToRule: 'unique-variant-name',
                        samples: ['"Black"','"2X-Large"','"Left Handed"']
                    },
                    {
                        key: 'Category',
                        label: 'Category',
                        dataType: 'productVariantTypes',
                        hasErrorCalculator: value => {
                            return this.isEmpty(value) || !this.matchesExistingObject(value);
                        },
                        rules: 'required|min_value:0',
                        samples: ['Color', 'Size', 'Other']
                    },
                    {
                        key: 'ActiveStatus',
                        label: 'Active Status',
                        dataType: 'yesNoOptions',
                        hasErrorCalculator: value => {
                            return this.isEmpty(value) || !this.matchesExistingObject(value);
                        },
                        rules: 'required|min_value:0',
                        samples: ['Yes', 'No', 'Yes']
                    }
                ]
            }
        };
    },
    methods: {
        // A variant name is only unique within its category, so the same name in a different
        // category is not a duplicate.  Variants that already exist are handled by the import
        // mode, which leaves this to catch a name repeated within the file itself.
        isDuplicateVariant(variantName, rowData, checkOriginalData) {
            if (this.isEmpty(variantName) || !rowData) {
                return false;
            }

            let name = (variantName + '').toLowerCase();
            return this.loadedData.filter(x =>
                x.CategoryId === rowData.CategoryId
                && ((x.VariantName ?? '').toLowerCase() === name
                    || (checkOriginalData
                        && (x.originalData?.VariantName ?? '').toLowerCase() === name))
            ).length > 1;
        }
    }
};
